import { render, staticRenderFns } from "./ServicesEditModal.vue?vue&type=template&id=387337bf&scoped=true"
import script from "./ServicesEditModal.vue?vue&type=script&lang=js"
export * from "./ServicesEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387337bf",
  null
  
)

export default component.exports